import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-services8',
  templateUrl: './section-services8.component.html',
  styleUrls: ['./section-services8.component.css']
})
export class SectionServices8Component implements OnInit {

  @Input() data: any;
  
  constructor() { }

  ngOnInit(): void {
  }

}
